<div class="mx-auto max-w-(--breakpoint-2xl) space-y-8">
  <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h1 class="text-2xl font-semibold text-gray-900 dark:text-white">Reports</h1>
      <p class="text-sm text-gray-500 dark:text-gray-400">Generate and download Excel reports.</p>
    </div>
    <div class="w-full sm:w-72">
      <app-text-input
        [control]="searchControl"
        [name]="'report_search'"
        placeholder="Search reports"
      ></app-text-input>
    </div>
  </div>

  <div class="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
    @for (report of reportTypes; track report) {
      <button
        type="button"
        class="flex h-full flex-col gap-3 rounded-xl border border-gray-200 bg-white p-5 text-left shadow-sm transition hover:border-brand-500 hover:shadow-md dark:border-gray-800 dark:bg-gray-900"
        (click)="createReport(report.type)"
      >
        <div class="flex items-center gap-3">
          <lucide-icon [name]="ReportIcon" [size]="22" class="text-brand-500"></lucide-icon>
          <h3 class="text-base font-semibold text-gray-900 dark:text-white">{{ report.title }}</h3>
        </div>
        <p class="text-sm text-gray-500 dark:text-gray-400">{{ report.description }}</p>
        <span class="mt-auto text-sm font-medium text-brand-600">Create report</span>
      </button>
    }
  </div>

  @if (reportsPage && !hasReports) {
    <div class="rounded-2xl border border-gray-200 bg-white px-6 py-12 text-center text-gray-500 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400">
      <div class="flex flex-col items-center justify-center gap-4">
        <lucide-icon [name]="ReportIcon" [size]="34" class="text-brand-500"></lucide-icon>
        <div>
          <p class="text-base font-semibold text-gray-900 dark:text-white">No reports yet</p>
          <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Choose a report type above to generate your first export.</p>
        </div>
      </div>
    </div>
  } @else {
    <app-data-table
      [title]="'Generated Reports'"
      [dataPage]="reportsPage"
      [columns]="tableColumns"
      [rowActions]="rowActions"
      (route)="handleRoute($event)"
    >
      <div header class="flex w-full items-center justify-end">
        <app-button
          [label]="'Refresh'"
          [style]="'secondary'"
          [icon]="RefreshIcon"
          (click)="refreshReports()"
        ></app-button>
      </div>
    </app-data-table>
  }
</div>
